import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=f2718d1c&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=ts&"
export * from "./Player.vue?vue&type=script&lang=ts&"
import style0 from "./Player.vue?vue&type=style&index=0&id=f2718d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2718d1c",
  null
  
)

export default component.exports